module.exports = __webpack_public_path__ + "static/code-982ef5978d876ef883a8264e568469b9.webp";